<template>
  <div class="contact-search-item">
    <standard
      :deletable="false"
      :contact="contact"
      :source="source"
      :selected="selected"
      class="contact-details"
    />
    <base-list-item
      class="contact-source"
      :selected="selected"
      v-if="showSource"
    >
      <img v-if="source === 'db'" :src="logo" alt="" />
      <div
        v-if="source === 'skeleton'"
        class="location-search-skeleton-source skeleton"
      ></div>
      <svg
        v-if="source === 'search'"
        width="68"
        height="18"
        viewBox="0 0 68 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.3404 5.60997C27.6562 5.60997 25.4802 7.78596 25.4802 10.4702C25.4802 13.1544 27.6562 15.3304 30.3404 15.3304C33.0247 15.3304 35.2007 13.1544 35.2007 10.4702C35.2007 7.78596 33.0247 5.60997 30.3404 5.60997ZM24.457 10.4702C24.457 7.22086 27.0911 4.58677 30.3404 4.58677C33.5898 4.58677 36.2239 7.22086 36.2239 10.4702C36.2239 13.7195 33.5898 16.3536 30.3404 16.3536C27.0911 16.3536 24.457 13.7195 24.457 10.4702Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.7778 13.9071C33.9776 13.7073 34.3015 13.7073 34.5013 13.9071L37.6093 17.0151C37.8091 17.2148 37.8091 17.5388 37.6093 17.7386C37.4095 17.9384 37.0855 17.9384 36.8858 17.7386L33.7778 14.6306C33.578 14.4308 33.578 14.1069 33.7778 13.9071Z"
          fill="currentColor"
        />
        <path
          d="M4.57943 16.2738C3.66941 16.2738 2.82544 16.1197 2.04753 15.8115C1.26961 15.5033 0.587106 15.0336 0 14.4024L0.506381 13.6319C1.13752 14.2336 1.776 14.674 2.42181 14.9529C3.06763 15.217 3.77216 15.3491 4.5354 15.3491C5.5188 15.3491 6.31139 15.1437 6.91317 14.7327C7.52963 14.3217 7.83787 13.7493 7.83787 13.0154C7.83787 12.5164 7.69109 12.1347 7.39754 11.8705C7.11866 11.5917 6.70769 11.3715 6.16462 11.21C5.63622 11.0339 4.99041 10.8504 4.22717 10.6596C3.44925 10.4541 2.78875 10.2413 2.24568 10.0212C1.71728 9.80099 1.32099 9.51478 1.05679 9.16252C0.792594 8.81025 0.660496 8.33323 0.660496 7.73144C0.660496 6.98288 0.843965 6.36642 1.21091 5.88206C1.59253 5.38302 2.0989 5.01608 2.73004 4.78123C3.37586 4.53171 4.08773 4.40695 4.86564 4.40695C5.76098 4.40695 6.5389 4.55373 7.19939 4.84728C7.87456 5.14084 8.38828 5.5298 8.74055 6.01416L8.1461 6.71869C7.77916 6.249 7.30213 5.90407 6.71503 5.68391C6.12792 5.44907 5.48211 5.33165 4.77758 5.33165C4.24918 5.33165 3.75014 5.40503 3.28045 5.55181C2.81077 5.69859 2.42915 5.94077 2.1356 6.27836C1.85672 6.60126 1.71729 7.04159 1.71729 7.59935C1.71729 8.03968 1.82003 8.3846 2.02552 8.63412C2.24568 8.88364 2.56859 9.08913 2.99424 9.25058C3.41989 9.39736 3.94829 9.55881 4.57943 9.73494C5.47476 9.95511 6.24534 10.1826 6.89116 10.4175C7.53698 10.6523 8.03602 10.9605 8.38828 11.3421C8.74054 11.7091 8.91668 12.2301 8.91668 12.9053C8.91668 13.9474 8.52038 14.7694 7.72778 15.3712C6.93519 15.9729 5.88574 16.2738 4.57943 16.2738Z"
          fill="currentColor"
        />
        <path
          d="M16.3696 16.2738C15.5623 16.2738 14.8138 16.1197 14.1239 15.8115C13.4341 15.4886 12.8323 15.0556 12.3186 14.5125C11.8195 13.9548 11.4232 13.3163 11.1297 12.5971C10.8508 11.8632 10.7114 11.0926 10.7114 10.2854C10.7114 9.19921 10.9535 8.21581 11.4379 7.33515C11.9223 6.45449 12.5901 5.74996 13.4414 5.22156C14.2927 4.67849 15.2468 4.40695 16.3036 4.40695C17.3897 4.40695 18.3511 4.67849 19.1877 5.22156C20.0243 5.76464 20.6848 6.48384 21.1692 7.37918C21.6682 8.25984 21.9178 9.22857 21.9178 10.2854C21.9178 10.3734 21.9178 10.4615 21.9178 10.5496C21.9178 10.6376 21.9104 10.711 21.8957 10.7697H11.8562C11.9149 11.6357 12.1571 12.421 12.5828 13.1255C13.0084 13.83 13.5515 14.3878 14.212 14.7987C14.8872 15.195 15.621 15.3932 16.4136 15.3932C17.2062 15.3932 17.9548 15.1877 18.6593 14.7767C19.3638 14.3657 19.8555 13.8373 20.1344 13.1915L21.1031 13.4557C20.883 13.9988 20.5307 14.4832 20.0464 14.9088C19.5767 15.3345 19.0189 15.6721 18.3731 15.9216C17.742 16.1564 17.0741 16.2738 16.3696 16.2738ZM11.8122 9.91108H20.861C20.8023 9.01574 20.5674 8.22315 20.1564 7.5333C19.7455 6.84345 19.2024 6.30037 18.5272 5.90407C17.8667 5.50778 17.1328 5.30963 16.3256 5.30963C15.5183 5.30963 14.7844 5.50778 14.1239 5.90407C13.4634 6.30037 12.9277 6.84345 12.5167 7.5333C12.1057 8.22315 11.8709 9.01574 11.8122 9.91108Z"
          fill="currentColor"
        />
        <path
          d="M45.0098 5.6142C43.9824 5.64356 43.0797 5.95179 42.3018 6.5389C41.5385 7.11133 41.0028 7.90392 40.6946 8.91668V16.072H39.5938V4.62346H40.6505V7.44157C41.0468 6.6343 41.5752 5.98115 42.2357 5.4821C42.8962 4.96839 43.5934 4.67483 44.3273 4.60145C44.4741 4.58677 44.6062 4.57943 44.7236 4.57943C44.841 4.57943 44.9364 4.57943 45.0098 4.57943V5.6142Z"
          fill="currentColor"
        />
        <path
          d="M51.5116 16.2922C50.719 16.2922 49.9777 16.1381 49.2879 15.8299C48.598 15.5069 47.9962 15.074 47.4825 14.5309C46.9688 13.9731 46.5652 13.3347 46.2716 12.6154C45.9927 11.8962 45.8533 11.1257 45.8533 10.3037C45.8533 9.20289 46.0955 8.21215 46.5799 7.33149C47.0642 6.45083 47.7321 5.7463 48.5834 5.21791C49.4347 4.68951 50.4034 4.42531 51.4895 4.42531C52.5316 4.42531 53.449 4.66749 54.2416 5.15186C55.0342 5.62154 55.6286 6.26736 56.0249 7.08931L54.9461 7.44157C54.6085 6.81043 54.1242 6.31873 53.493 5.96647C52.8766 5.59953 52.1941 5.41605 51.4455 5.41605C50.6089 5.41605 49.853 5.62888 49.1778 6.05453C48.5026 6.48019 47.9596 7.06729 47.5486 7.81585C47.1523 8.54973 46.9541 9.37902 46.9541 10.3037C46.9541 11.2137 47.1596 12.0504 47.5706 12.8136C47.9816 13.5768 48.5246 14.186 49.1998 14.641C49.8897 15.0813 50.6456 15.3015 51.4675 15.3015C51.9959 15.3015 52.5096 15.2061 53.0087 15.0152C53.5224 14.8098 53.9627 14.5456 54.3297 14.2226C54.7113 13.8997 54.9608 13.5548 55.0782 13.1879L56.157 13.4961C55.9662 14.0392 55.636 14.5235 55.1663 14.9492C54.6966 15.3602 54.1462 15.6904 53.515 15.9399C52.8986 16.1748 52.2308 16.2922 51.5116 16.2922Z"
          fill="currentColor"
        />
        <path
          d="M68.0002 16.072H66.8994V9.68725C66.8994 8.2782 66.6572 7.22141 66.1728 6.51688C65.6884 5.79767 64.9839 5.43807 64.0592 5.43807C63.4574 5.43807 62.8557 5.59219 62.2539 5.90042C61.6521 6.20865 61.131 6.6343 60.6907 7.17737C60.2504 7.70577 59.9348 8.30755 59.744 8.98273V16.072H58.6432V0H59.744V7.35351C60.2137 6.45817 60.8668 5.7463 61.7035 5.21791C62.5401 4.68951 63.4281 4.42531 64.3675 4.42531C65.0133 4.42531 65.5637 4.54273 66.0187 4.77758C66.4737 5.01242 66.848 5.35001 67.1415 5.79034C67.4351 6.23067 67.6479 6.75906 67.78 7.37552C67.9268 7.99198 68.0002 8.69651 68.0002 9.48911V16.072Z"
          fill="currentColor"
        />
      </svg>
    </base-list-item>
  </div>
</template>
<script>
import Standard from "./Standard.vue";
import BaseListItem from "../BaseListItem.vue";
export default {
  computed: {
    logo() {
      return this.$store.getters.businessLogo;
    },
  },
  components: {
    Standard,
    BaseListItem,
  },
  props: ["contact", "selected", "source", "showSource"],
};
</script>
<style scoped>
@media screen {
  .contact-search-item {
    width: 100%;
    margin: 5px 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    filter: drop-shadow(0 0 4px var(--shadow));
  }

  .contact-details {
    margin-bottom: 0;
  }

  .contact-search-item:hover {
    filter: drop-shadow(0 0 4px var(--secondaryColor));
  }

  .skeleton {
    width: 45%;
    height: 80%;
    background-color: var(--backgroundColor);
    border-radius: 4px;
    filter: drop-shadow(0 0 2px var(--secondaryColor));
  }

  .contact-source {
    min-width: 100px;
    width: 100px;
    height: 60px;
    margin: 0 0 0 5px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    max-width: 90%;
    max-height: 90%;
  }

  @media (min-width: 800px) {
    .contact-source {
      min-width: 125px;
      margin: 0 5px;
    }

    img {
      max-width: 75%;
      max-height: 75%;
    }
  }
}
</style>
